/**
 * @generated SignedSource<<dbe094d516691854f74ad6ab1a27b2c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSwitcher$data = {
  readonly appSwitcher_unitProfile?: {
    readonly __typename: "AppSwitcherUnitProfile";
    readonly unitIconUrl: string | null;
    readonly unitName: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "AppSwitcher";
};
export type AppSwitcher$key = {
  readonly " $data"?: AppSwitcher$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppSwitcher">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "appSwitcherProductAri"
    },
    {
      "kind": "RootArgument",
      "name": "skipAppSwitcherUnitProfile"
    }
  ],
  "kind": "Fragment",
  "name": "AppSwitcher",
  "selections": [
    {
      "condition": "skipAppSwitcherUnitProfile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "productAri",
              "variableName": "appSwitcherProductAri"
            }
          ],
          "kind": "LinkedField",
          "name": "appSwitcher_unitProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "unitName"
                },
                {
                  "kind": "ScalarField",
                  "name": "unitIconUrl"
                }
              ],
              "type": "AppSwitcherUnitProfile"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "8bf3f4de6eec051c267b7805cc142266";

export default node;
